
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
// import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { MainService as md_mainService } from '../../../md/service/main.service';
import { AllEmpService } from '../../../hrms/service/all-emp.service';
import { UserlogService } from '../../service/userlog.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { DataAccessService } from '../../service/data-access.service';
import { HrHierService } from '../../../hrms/service/hr-hier.service';
import { EstablishService } from '../../../hrms/service/establish.service';
import { LogService } from '../../../portal/service/log.service';
import { JoiningService } from '../../../hrms/service/joining.service';
import { EstablishmentService } from '../../../hrms/service/establishment.service';
import { MainService } from '../../service/main.service';
declare var $: any;
import { session } from '../../../../environments/environment.session'
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  displayedColumns: string[] = ['user_id', 'name', 'phone_no', 'email', 'role_desc', 'action'];
  email: any;
  password: any;
  confirm_pass: any;
  users: any = [];
  datasource: any;
  user_id: any;
  index: any;
  Obj: any = {};
  FirstName: any;
  LastName: any;
  User_Email: any;
  b_acct_id: any;
  ebillUser: any
  message: any;
  errorMsg: any;
  logObj = { component: 'USER' }
  fourth: any;
  second: any;
  third: any;
  isLinear: any;
  first: any;
  constructor(public mainService1: MainService, private establishmentService: EstablishmentService, private joiningservice: JoiningService,
    private establishService: EstablishService, private hrHierService: HrHierService, private dataAccessService: DataAccessService,
    private userlog: UserlogService, private spinner: NgxSpinnerService, private allEmpService: AllEmpService,
    private mainService: md_mainService, private sanitizer: DomSanitizer, private log: LogService) { }
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  @ViewChild('stepper1', { static: false }) stepper1!: MatStepper;
  @ViewChild('stepper2', { static: false }) stepper2!: MatStepper;

  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id
    this.message = "visit on user component"
    console.log(this.mainService1)
    this.user_id = this.ebillUser.user_id;
    let resp = await this.userlog.insertLoginInfo(this.message);
    await this.getCurrentLegalEntity()
    await this.getAllAccountModule();
    await this.getCurrentRole()
    await this.getCurrentUsers()
    await this.getAllEmployees()

    await this.getAllSystemRole();
    await this.getArrIdInfo(this.b_acct_id);
    await this.getAssignedEmpInfo(this.b_acct_id, this.ebillUser.user_id);
    await this.getAccountProjectHier();
    await this.getAllProduct();
    await this.getAllBudget();
    // await this.getcurrentroleswithresources()
  }
  checkEmail(obj: any) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (obj.match(mailformat)) {


      let d = obj.split('.');

      if ((d != undefined || d != null)) {
        if ((d[(d.length) - 1] === 'com') || (d[(d.length) - 1] === 'in') || (d[(d.length) - 1] === 'org') || (d[(d.length) - 1] === 'co')) {
          this.avivalid = true;
          this.spanAvi = true;
        }
        else {
          this.avivalid = false;
          this.spanAvi = false;
        }

      }
    }
    else {
      this.avivalid = false;
      this.spanAvi = false;
    }
  }
  allBudget = []
  async getAllBudget() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;

    var resp = await this.allEmpService.getAllBugdet(obj);
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Budget Received Successfully " })
      this.allBudget = resp.data;
    }
  }

  allProduct = []
  async getAllProduct() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;

    var resp = await this.allEmpService.getAllProduct(obj);
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Product Received Successfully " })
      this.allProduct = resp.data;
    }
  }
  selectedModule(module_cd: any) {
    console.log(module_cd)
    this.planing_arrproj = [];
    this.Obj = {}
  }
  list_flag = true
  create_flag = false
  update_flag = false
  open_create() {

    this.list_flag = false
    this.create_flag = true
    this.update_flag = false
    this.add_user_flag = false
    this.Obj = {}
  }
  async open_list() {
    this.list_flag = true
    this.create_flag = false
    this.update_flag = false
    this.add_user_flag = false
    await this.getCurrentLegalEntity()
    await this.getCurrentRole()
    await this.getCurrentUsers()
    await this.getAllEmployees()
    await this.getAllBudget();
  }
  // async getcurrentroleswithresources() {
  //   this.spinner.show()
  //   let obj :any= {}
  //   obj['b_acct_id'] = this.b_acct_id
  //   obj['module_cd']='USTP'
  //   console.log(obj)
  //   var resp = await this.mainService.getcurrentroleswithresources(JSON.stringify(obj));
  //   console.log(resp);
  //   if (resp['error'] == false) {
  //     this.spinner.hide()
  //     // this.current_role = resp['data']
  //     // this.Obj['c3']=this.current_rol/e.length
  //     console.log(resp,'getcurrentroleswithresources:dtls');
  //     this.datasource = new MatTableDataSource(resp.data);
  //     this.datasource.paginator = this.paginator;
  //     this.datasource.sort = this.sort;
  //   } else {
  //     this.spinner.hide()
  //     Swal.fire("Error", "..Error while getting  roles", 'error');
  //   }
  // }
  getNumberFormat(num: any) {
    return num.toString().padStart(3, "0")
  }
  allEmplyees_new: any = []
  allEmployees: any = []
  allSearchableEmp: any = []
  async getAllEmployees() {
    console.log('all emp')
    this.spinner.show()
    var arr: any = []
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = 'NOC'
    var resp = await this.mainService.getuserformodulerolemapping(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Received User For Module Role Mapping" })
      this.spinner.hide()
      arr = resp.data;
      // for (let i = 0; i < arr.length; i++) {
      //   var obj :any = new Object();
      //   obj = Object.assign({}, arr[i]);
      //   obj['tempid'] = this.mainService.accInfo['account_short_name'] + this.getNumberFormat(obj['emp_id'])
      //   this.allEmployees.push(obj)
      // }
      // this.allEmplyees_new = [];
      // for (let i = 0; i < resp.data.length; i++) {
      //   var obj :any = new Object();
      //   obj = Object.assign({}, resp.data[i]);
      //   obj['emp_name'] = this.mainService.accInfo['account_short_name'] + this.getNumberFormat(obj['emp_id']) + "-" + obj['emp_name']
      //   this.allEmplyees_new.push(obj)
      // }
      // for (let i = 0; i < arr.length; i++) {
      //   for (let j = 0; j < this.current_LE.length; j++) {
      //     if (this.current_LE[j]['phone_no'] == arr[i]['emp_phone_no']) {
      //       arr[i]['le_id'] = this.current_LE[j]['le_id']
      //     }
      //   }
      // }
      for (let i = 0; i < arr.length; i++) {
        arr[i]['desc'] = arr[i]['user_id'] + " - " + arr[i]['emp_name'] + " - " + arr[i]['emp_phone_no']
      }
      this.allSearchableEmp = arr

    } else {
      this.spinner.hide()
    }
    console.log(this.allEmployees, this.allEmplyees_new, this.current_LE, arr, 'employees')
  }
  current_role: any = []
  async getCurrentRole() {
    this.spinner.show()
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = 'NOC';
    console.log(obj)
    var resp = await this.mainService.getCurrentMdRole(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Current Role Received Successfully " })
      this.spinner.hide()
      this.current_role = resp['data']
      console.log(resp);
    } else {
      this.spinner.hide()
      Swal.fire("Error", "..Error while getting  roles", 'error');
    }
  }
  allUsers: any = []
  async getCurrentUsers() {
    console.log('called this funnction')
    this.spinner.show()
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id;
    obj['module_cd'] = 'NOC'
    console.log(obj)
    var resp = await this.mainService.getCurrentMdUser(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Current USer Received Successfully " })
      this.allUsers = resp['data']
      this.spinner.hide()
      var emp_id: any = new Object();
      for (let i = 0; i < resp['data'].length; i++) {
        for (let j = 0; j < this.current_role.length; j++) {
          if (this.current_role[j]['role_cd'] == resp['data'][i]['role_cd']) {
            if (emp_id[resp['data'][i]['user_id']] == undefined) {
              resp['data'][i]['role_name'] = this.current_role[j]['role_name']
              emp_id[resp['data'][i]['user_id']] = resp['data'][i]
            } else {
              emp_id[resp['data'][i]['user_id']]['role_name'] = this.current_role[j]['role_name'] //emp_id[resp['data'][i]['user_id']]['role_name'] + " , " +
            }
          }
        }
      }


      console.log(emp_id)
      var data: any = Object.values(emp_id);

      console.log(data)


      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < this.current_LE.length; j++) {
          if (this.current_LE[j]['le_id'] == data[i]['user_id']) {
            data[i]['party_name'] = this.current_LE[j]['party_name']
            data[i]['contact_email'] = this.current_LE[j]['contact_email']
            data[i]['phone_no'] = this.current_LE[j]['phone_no']
          }
        }
      }
      console.log(data)
      this.datasource = new MatTableDataSource(data);
      this.datasource.paginator = this.paginator.toArray()[0];
      this.datasource.sort = this.sort.toArray()[0];
    } else {
      this.spinner.hide()
      Swal.fire("Error", "..Error while getting  roles", 'error');
    }
  }
  allModule: any = [];
  moduleObj: any = {}
  async getAllAccountModule() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.mainService.getAccountModules(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Account Module Received Successfully " })
      this.allModule = resp.data;
      console.log(this.allModule)
      this.allModule = [{ is_for_only_system_use: 0, module_cd: "NOC", module_id: 29, module_name: "PET REGISTARTION", module_url: null }]


      for (let i = 0; i < this.allModule.length; i++) {
        this.moduleObj[this.allModule[i]['module_cd']] = this.allModule[i]['module_name']
      }

      for (let i = 0; i < this.allModule.length; i++) {
        if (this.allModule[i]['module_cd'] == 'ENG') {
          this.allModule.splice(i, 1)
        }
      }
      console.log(this.moduleObj)
    } else {
      Swal.fire('Error', 'Some Error Occured', 'error')
    }
  }
  allRole: any = []
  allModuleRole: any = []
  moduleToRole: any = {};
  roleToModule: any = {};
  async getAllSystemRole() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.mainService.getCurrentMdrole(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All Current Module Role Received Successfully " })
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]['is_system_role'] == 1) {
          this.allModuleRole.push(resp.data[i])
          this.moduleToRole[resp.data[i]['module_cd']] = resp.data[i]['role_cd']
          this.roleToModule[resp.data[i]['role_cd']] = resp.data[i]['module_cd']

        }
      }
    } else {
      Swal.fire('Error', 'Some Error Occured', 'error')
    }

    console.log(this.allModuleRole)
  }
  current_LE = []
  ind_current_LE = []
  org_current_LE = []
  async getCurrentLegalEntity() {
    this.current_LE = []
    this.ind_current_LE = []
    this.org_current_LE = []
    var resp = await this.mainService.getCurrentLegalEntity(this.b_acct_id);
    console.log(resp);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Current Legal Entity Received Successfully " })
      console.log(resp);
      this.current_LE = resp['data']
      let ind: any = []
      let org: any = []
      for (let i = 0; i < this.current_LE.length; i++) {
        if (this.current_LE[i]['party_type'] == 'IND') {
          ind.push(this.current_LE[i])
        } else {
          org.push(this.current_LE[i])
        }
      }
      this.ind_current_LE = ind
      this.org_current_LE = org
    } else {
      Swal.fire("Error", "..Error while getting current Legal Entity", 'error');
    }
  }
  setDetails() {
    if (this.Obj['user_id']) {
      for (let i = 0; i < this.allSearchableEmp.length; i++) {
        if (this.Obj['user_id'] == this.allSearchableEmp[i]['le_id']) {
          this.Obj['name'] = this.allSearchableEmp[i]['emp_name']
          this.Obj['email'] = this.allSearchableEmp[i]['emp_email']
          this.Obj['phone'] = this.allSearchableEmp[i]['emp_phone_no']
          this.Obj['user_id'] = this.allSearchableEmp[i]['le_id']
          this.Obj['allow_create'] = 'YES' // let flag
          console.log(this.allSearchableEmp[i])
          break;
        }
      }
    } else {
      this.Obj['name'] = null
      this.Obj['email'] = null
      this.Obj['phone_no'] = null
    }
  }
  open_update(element: any) {
    this.list_flag = false
    this.create_flag = false
    this.update_flag = true
    this.Obj = element;
    $('.nav-tabs a[href="#tab-7-3"]').tab('show');
  }
  add_user_flag = false
  open_add_user() {
    this.list_flag = false
    this.create_flag = false
    this.update_flag = false
    this.add_user_flag = true
  }

  submit_act() {
    console.log(this.planing_arrproj[this.planing_arrproj.length - 1]['hierarchy_type']);
    if (this.planing_arrproj.length < 2 || this.planing_arrproj[this.planing_arrproj.length - 1]['hierarchy_type'] == null || this.planing_arrproj[this.planing_arrproj.length - 1]['hierarchy_type'] == null) {
      Swal.fire("Warning", "Please Select at least two level", 'warning')
    }
    else {

      $('#ACTHIER').modal('hide');
    }
    this.joiningObj['node_cd'] = this.planing_arrproj[this.planing_arrproj.length - 1]['hierarchy_type']
  }

  joiningObj: any = {};
  stepperIndex: any = 0;
  dob_blank: any = true;
  disable_flag: boolean = false;
  party_exit: boolean = false;
  avivalid: boolean = false
  spanAvi: boolean = false;
  gAvi: boolean = false;
  async search1() {
    if (this.joiningObj['credential'] == null || this.joiningObj['credential'] == undefined || this.joiningObj['credential'] == '') {
      Swal.fire("Warning", 'Mobile Number or Email can not be null', 'warning')
      return
    }
    if (isNaN(this.joiningObj['credential'])) {
      // var emailRegx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/im;
      var emailRegx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      if (!this.joiningObj['credential'].match(emailRegx)) {
        // if (emailRegx.test(this.joiningObj['credential'])){
        Swal.fire("Error", 'Invalid Email', 'error')
        return
      }
    } else {
      let mobRegx = /^[0-9]{10}$/;
      if (!mobRegx.test((this.joiningObj['credential']))) {
        Swal.fire("Error", 'Mobile Number Should be  10 digit', 'error')
        return
      }
    }

    this.disable_flag = false
    this.joiningObj['emp_name'] = null;
    this.joiningObj['emp_email'] = null;
    this.joiningObj['emp_phone_no'] = null;
    this.joiningObj['emp_dob'] = null;
    this.joiningObj['le_id'] = null;
    console.log(this.joiningObj['credential'])
    if (await this.findEmployeeInAccount()) {
      this.spanAvi = true
      $('#myModal1').modal('show');
      return;
    }


    this.joiningObj['b_acct_id'] = this.b_acct_id
    console.log(isNaN(this.joiningObj['credential']))

    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id
    if (isNaN(this.joiningObj['credential'])) {
      obj['contact_email'] = this.joiningObj['credential']
      this.joiningObj['emp_email'] = this.joiningObj['credential']
    } else {
      obj['phone_no'] = this.joiningObj['credential']
      this.joiningObj['emp_phone_no'] = this.joiningObj['credential']
    }

    console.log(this.joiningObj)
    if (!this.joiningObj['credential']) {
      Swal.fire('Error', 'Please Enter Valid Credential', 'error')
    } else {
      this.spinner.show()
      var resp = await this.mainService.getCurrentLegalEntity(JSON.stringify(obj));
      console.log(resp)
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'GET', message: "Current Legal Entity Received Successfully " })
        this.spinner.hide();
        this.data = resp['data']
        if (resp['data'].length > 0) {

          if (resp['data'][0]['party_type'] == 'ORG') {
            this.spinner.hide();
            Swal.fire('Error', 'Please Enter Valid Legal Entity Not Org..', 'error');
            return;

          }

          // this.avivalid=true;
          this.spanAvi = true;
          this.avivalid = true;
          this.disable_flag = true;
          this.party_exit = true;
          this.joiningObj['emp_name'] = resp['data'][0]['party_name']
          this.joiningObj['emp_email'] = resp['data'][0]['contact_email']
          this.joiningObj['emp_phone_no'] = resp['data'][0]['phone_no']
          this.joiningObj['le_id'] = resp['data'][0]['le_id'];
          this.joiningObj['le_id'] = resp['data'][0]['le_id'];
          if (resp['data'][0]['party_dob'] != null) {
            this.dob_blank = false;
            this.joiningObj['emp_dob'] = resp['data'][0]['party_dob'].split('T')[0];
          } else {
            this.dob_blank = true;

          }
          this.joiningObj['new_entity'] = false;
          this.joiningObj['ident_verify_secret'] = 'User@1';
          Swal.fire('Warning...', 'A person with searched email/phone number is already available. Following are the details for this person. If you want to add this person as employee then you can continue by clcking "next". If this is not the person that you wanted to add then please click "Back" and search using different phone and/or email.', 'warning')

        } else {
          this.party_exit = false;
          this.dob_blank = true;

          this.joiningObj['new_entity'] = true;
          this.joiningObj['ident_verify_secret'] = 'User@1';
          this.joiningObj['party_type'] = "IND";
          this.spinner.hide()
          Swal.fire('Info...', 'No person found with searched email/phone in the system. Please fill the details to create identity for the employee that you want to add', 'info')
        }
      } else {
        this.spinner.hide()
        Swal.fire('Error', 'Some Error Occured', 'error')
      }
    }
    this.stepper1.next();
    console.log(resp);
  }
  data: any = []
  allEmplyees: any = []
  modobj: any = {}
  exitingEmployee: any
  findEmployeeInAccount() {
    var get = false;
    if (isNaN(this.joiningObj['credential'])) {
      for (let i = 0; i < this.allEmplyees.length; i++) {
        if (this.allEmplyees[i]['emp_email'] == this.joiningObj['credential']) {
          get = true;
          this.exitingEmployee = this.allEmplyees[i]
          console.log(this.exitingEmployee);
          this.modobj = this.exitingEmployee

        }
      }
    } else {
      for (let i = 0; i < this.allEmplyees.length; i++) {

        if (this.allEmplyees[i]['emp_phone_no'] == this.joiningObj['credential']) {
          get = true;
          this.exitingEmployee = this.allEmplyees[i];
          console.log(this.exitingEmployee);
          this.modobj = this.exitingEmployee
        }
      }
    }

    console.log(get)
    return get;
  }

  async update() {
    this.open_list()

  }

  account: any


  single_users_role: any = []
  selected_row: any = {}
  modalOpen(data: any) {
    this.selected_row = {}
    this.selected_row = Object.assign({}, data)
    this.single_users_role = []
    let dummy = []
    for (let i = 0; i < this.allUsers.length; i++) {
      if (data['user_id'] == this.allUsers[i]['user_id']) {
        dummy.push(this.allUsers[i])
      }
    }
    for (let i = 0; i < dummy.length; i++) {
      for (let j = 0; j < this.current_role.length; j++)
        if (dummy[i]['role_cd'] == this.current_role[j]['role_cd']) {
          dummy[i]['role_desc'] = this.current_role[j]['role_desc']
        }
    }
    this.single_users_role = dummy
    console.log(data, this.allUsers)

    $('#myModal1').modal('show');

  }
  async delete(element: any) {
    console.log(element)
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then((result) => {
      if (result.value) {
        this.finaldelete(element)
      }
    })
  }
  async finaldelete(element: any) {
    let obj: any = {}
    obj = Object.assign({}, element)
    obj['b_acct_id'] = this.b_acct_id
    this.spinner.show()
    var resp = await this.mainService.deleteUser_MD(obj)
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'DELETE', message: "Module User Deleted Successfully " })
      this.spinner.hide()
      await this.getCurrentUsers()
      await this.modalOpen(this.selected_row)
      this.message = "deleted user role"
      let resp = await this.userlog.insertLoginInfo(this.message);
      Swal.fire('Success', 'Deleted Successfully', 'success')
    } else {
      this.spinner.hide()
      Swal.fire('Error', resp['data'], 'error')
    }
  }

  email_Validate(emailAdress: any) {
    var EMAIL_REGEXP = new RegExp('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$', 'i');
    return EMAIL_REGEXP.test(emailAdress)
  }
  CheckPassword(inputtxt: any) {
    var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if (passw.test(this.Obj['password'])) {
      return true;
    }
    else {
      return false;
    }
  }
  // data = []
  async search() {
    let flag = false
    this.spinner.show()
    this.Obj['name'] = null
    this.Obj['email'] = null
    this.Obj['phone_no'] = null
    console.log(this.allSearchableEmp)
    if (this.Obj['credential']) {
      for (let i = 0; i < this.allSearchableEmp.length; i++) {
        if (this.Obj['credential'] == this.allSearchableEmp[i]['emp_phone_no']) {
          this.Obj['name'] = this.allSearchableEmp[i]['emp_name']
          this.Obj['email'] = this.allSearchableEmp[i]['emp_email']
          this.Obj['phone'] = this.allSearchableEmp[i]['emp_phone_no']
          this.Obj['user_id'] = this.allSearchableEmp[i]['le_id']
          this.Obj['allow_create'] = 'YES' // let flag
          flag = true
          this.spinner.hide()
          break
        } else {
          let flag = false
          this.spinner.hide()
          this.Obj['name'] = null
          this.Obj['email'] = null
          this.Obj['phone'] = null
          this.Obj['user_id'] = null
          this.Obj['phone_no'] = null
        }
      }
    } else {
      Swal.fire('Error', 'Please Enter Valid Mobile Number', 'error')
      this.spinner.hide()
      this.Obj['name'] = null
      this.Obj['email'] = null
      this.Obj['phone'] = null
      this.Obj['user_id'] = null
      this.Obj['phone_no'] = null
    }
    if (flag == false) {
      Swal.fire('Error', 'This Mobile Number`s Record Not Found', 'error')

    }
  }

  async submit() {
    console.log('yes....')
    console.log(this.Obj)
    if (!this.Obj['user_id']) {
      Swal.fire('Error', 'Please Select All * Fields', 'error')
    } else if (!this.Obj['role_cd']) {
      Swal.fire('Error', 'Please Select Role', 'error')
    } else {
      console.log(this.Obj)
      this.Obj['b_acct_id'] = this.b_acct_id
      this.Obj['valid_upto'] = '2030-04-30'
      this.Obj['module_cd'] = 'NOC'
      this.spinner.show()
      var resp = await this.mainService.createMdUser(this.Obj)
      console.log(resp)
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'GET', message: "Module USer Created Successfully " })
        this.spinner.hide()
        this.message = "user mapped"
        let resp = await this.userlog.insertLoginInfo(this.message);
        Swal.fire('Success...', 'Created Successfully', 'success')
        this.getCurrentUsers()
        this.open_list()
        this.Obj = {}
      } else {
        this.spinner.hide()
        if (resp['data'] == "Duplicate entry") {
          Swal.fire('Error...', 'This user already has this role.', 'info')
        } else {
          Swal.fire('Error', 'Error While Creating', 'error')
        }
      }
    }
  }
  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  refresh() {
    this.Obj = {}
    this.data = []
  }
  planing_arrproj: any = []
  open_activitypopup() {
    if (this.planing_arrproj.length == 0) {
      this.down({}, -1)
    }

    console.log("Open Pop Up")
    $('#ACTHIER').modal('show');
  }
  allProject: any = [];

  ArrIdToWOrkIDObj: any = {}
  UserIdToArrIdObj: any = {}
  async getArrIdInfo(b_acct_id: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    this.ArrIdToWOrkIDObj = {}
    this.UserIdToArrIdObj = {}
    var resp = await this.establishService.getAllArrangment(JSON.stringify(obj));
    console.log(resp, 'getArrInfo')
    console.log(resp)
    if (resp['error'] == false) {
      for (let i = 0; i < resp.data.length; i++) {
        this.ArrIdToWOrkIDObj['USTPARR' + resp.data[i]['arr_id']] = resp.data[i]['arr_id']
        this.UserIdToArrIdObj[resp.data[i]['cp_le_id']] = resp.data[i]['arr_id']
      }
    }
    console.log(this.ArrIdToWOrkIDObj)
  }

  //  active=false;
  assignedEmp: any = {};

  data_assigment: any = []
  async getAssignedEmpInfo(b_acct_id: any, user_id: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['user_id'] = user_id;
    //   if(active==true)
    //   {
    //     obj['active']=true;
    // console.log("We get this true function --- ",active, obj);
    //   }
    //   if(active==false || active=='')
    //   {
    //     obj['active']=false
    // console.log("We get this false function ... ", active, obj);
    //   }
    console.log(obj, 'getuserAssigneddata obj')
    var resp = await this.hrHierService.getAllHrdataAssigned(JSON.stringify(obj));


    console.log(resp, 'getuserAssigneddata Resp')
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "All HR Data Assigned Received Successfully" })
      console.log(resp.data);
      this.data_assigment = resp.data;
      this.data_assigment = this.data_assigment.filter((x: any) => x.user_id == user_id)
      this.assignedEmp = {};
      let work = await this.allEmpService.getAccountProjectHier(obj);
      let node = work['data']
      console.log(node)
      for (let i = 0; i < resp.data.length; i++) {
        if (resp['data'][i]['user_id'] == user_id) {
          let level = 0
          for (let j = 0; j < node.length; j++) {
            if (node[j]['leaf_cd'] == resp.data[i]['node_cd']) {
              console.log(node[j])
              for (let k = 1; k < 8; k++) {
                if (node[j]['lvl' + k + '_cd'] == resp.data[i]['node_cd']) {
                  level = k
                }
              }
            }
          }
          for (let j = 0; j < node.length; j++) {
            if (node[j]['is_leaf'] == 1 && node[j]['lvl' + level + '_cd'] == resp.data[i]['node_cd']) {
              if (this.ArrIdToWOrkIDObj[node[j]['leaf_user_cd']] != undefined) {
                this.assignedEmp[this.ArrIdToWOrkIDObj[node[j]['leaf_user_cd']]] = this.ArrIdToWOrkIDObj[node[j]['leaf_user_cd']]
              }
            }
          }
        }
      }
    }
    console.log(this.assignedEmp);
  }
  async getAccountProjectHier() {
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.allEmpService.getAccountProjectHier(obj);
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Account Project Hierarachy Received Successfully " })
      console.log(resp)
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]['lvl1_value'] == "All Projects") {
          resp.data[i]['lvl1_value'] = 'NNLKO'
        }
      }
      var data = [];
      for (let i = 0; i < resp.data.length; i++) {

        var tt = []
        for (let k = 1; k < 8; k++) {
          if (resp.data[i]['lvl' + k + '_cd'] != null) {
            tt.push(resp.data[i]['lvl' + k + '_cd'])
          }
        }
        // data_assigment = data_assigment.filter(x => x.user_id == this.user_id)
        this.data_assigment = this.data_assigment.filter((x: any) => x.user_id == this.user_id)

        var exit_flag = false;
        for (let j = 0; j < this.data_assigment.length; j++) {
          if (tt.includes(parseInt(this.data_assigment[j]['node_cd']))) {
            exit_flag = true;
          }
        }

        if (tt.length == 1) {
          exit_flag = true;
        }
        if (((resp.data[i]['lvl1_cd'] == resp.data[i]['leaf_cd']) || (resp.data[i]['lvl2_cd'] == resp.data[i]['leaf_cd']) || (resp.data[i]['module_cd'] == "NOC"))
          && (resp.data[i]['module_cd'] != null || resp.data[i]['module_cd'] != undefined) && exit_flag) {
          data.push(resp.data[i])
        }
      }

      console.log(data)

      resp['data'] = data;
      this.allProject = resp.data;
      this.projecthier = resp['data']
      for (let i = 0; i < resp['data'].length; i++) {
        for (let j = 1; j < 8; j++) {
          this.projhierobj[resp['data'][i]['lvl' + (j) + '_cd']] = resp['data'][i]['lvl' + (j) + '_value']
          this.projhierobjtype[resp['data'][i]['lvl' + (j) + '_cd']] = resp['data'][i]['lvl' + (j) + '_node_type']
          this.projhierobjtypecd[resp['data'][i]['lvl' + (j) + '_cd']] = resp['data'][i]['lvl' + (j) + '_user_cd']
          this.projhierobjisleaf[resp['data'][i]['lvl' + (j) + '_cd']] = resp['data'][i]['is_leaf']
        }
      }
    } else {
      console.log("Error in getting all project hier")
    }
  }
  check: any
  setHierarchyNodeitem(item: any, i: any) {
    console.log(item, i);
    this.check = item['hierarchy_type']
    console.log(this.check);
    item['is_leaf'] = this.projhierobjisleaf[item['hierarchy_type']]
    let flag = false
    let dummy2 = []
    for (let i = 0; i < this.planing_arrproj.length; i++) {
      dummy2.push(this.projhierobj[this.planing_arrproj[i]['hierarchy_type']])
    }
    this.Obj['path_desc'] = dummy2.join(' --> ');

  }
  projhierobj: any = {}
  projhierobjtype: any = {}
  projhierobjtypecd: any = {}
  projhierobjisleaf: any = {}
  projecthier: any = []
  down(item: any, k: any) {
    console.log(k)
    console.log(item)
    console.log(this.planing_arrproj)
    let patharr = []
    for (let i = 0; i < this.planing_arrproj.length; i++) {
      console.log(this.planing_arrproj[i])

      patharr.push(this.projhierobj[this.planing_arrproj[i]['hierarchy_type']])


    }
    this.Obj['path_desc'] = patharr.join("-->")
    this.planing_arrproj.push({ level: k + 2, existing_heirarchy_nodes: [] })
    console.log(this.planing_arrproj, item)
    let arr: any = []
    for (let i = 0; i < this.projecthier.length; i++) {
      if (!arr.includes(this.projecthier[i]['lvl' + (k + 2) + '_cd']) && this.projecthier[i]['lvl' + (k + 2) + '_cd'] != null) {

        if ((this.projecthier[i]['lvl' + (k + 1) + '_cd'] == item['hierarchy_type'] || k == -1) && this.projecthier[i]['leaf_node_type'] != 'USTPEMP') {

          if (k == 0) {
            arr = []
            for (let q = 0; q < this.joiningObj['module_cd'].length; q++) {
              if ((this.joiningObj['module_cd'][q] == this.projecthier[i]['module_cd']) && (this.projecthier[i]['lvl2_cd'] == this.projecthier[i]['leaf_cd'])) {
                console.log(this.projecthier[i])
                this.planing_arrproj[k + 1]['existing_heirarchy_nodes'].push({ node_cd: this.projecthier[i]['lvl' + (k + 2) + '_cd'], desc: this.projecthier[i]['lvl' + (k + 2) + '_user_cd'] + ' - ' + this.projecthier[i]['lvl' + (k + 2) + '_value'] + ' - ' + this.projecthier[i]['lvl' + (k + 2) + '_node_type'], is_leaf: this.projecthier[i]['is_leaf'] })
                arr.push(this.projecthier[i]['lvl' + (k + 2) + '_cd'])
              }
            }
          }
          else {
            this.planing_arrproj[k + 1]['existing_heirarchy_nodes'].push({ node_cd: this.projecthier[i]['lvl' + (k + 2) + '_cd'], desc: this.projecthier[i]['lvl' + (k + 2) + '_user_cd'] + ' - ' + this.projecthier[i]['lvl' + (k + 2) + '_value'] + ' - ' + this.projecthier[i]['lvl' + (k + 2) + '_node_type'], is_leaf: this.projecthier[i]['is_leaf'] })
            arr.push(this.projecthier[i]['lvl' + (k + 2) + '_cd'])
          }
        }
      }
    }
  }

  remove(item: any, i: any) {
    if (this.planing_arrproj.length > 1) {
      this.planing_arrproj.pop()
      let patharr = []
      for (let i = 0; i < this.planing_arrproj.length; i++) {
        console.log(this.planing_arrproj[i])

        patharr.push(this.projhierobj[this.planing_arrproj[i]['hierarchy_type']])
      }
      this.Obj['path_desc'] = patharr.join("-->")
    }

  }
  async addJoining() {

    console.log(this.joiningObj)
    this.errorMsg = ''
    if (this.joiningObj['emp_phone_no'] == null || this.joiningObj['emp_phone_no'] == undefined || this.joiningObj['emp_phone_no'] == ""
      || this.joiningObj['emp_dob'] == null || this.joiningObj['emp_dob'] == undefined || this.joiningObj['emp_dob'] == ""
      || this.joiningObj['emp_name'] == null || this.joiningObj['emp_name'] == undefined || this.joiningObj['emp_name'] == ""
      || this.joiningObj['emp_email'] == null || this.joiningObj['emp_email'] == undefined || this.joiningObj['emp_email'] == ""
      || this.joiningObj['module_cd'] == null || this.joiningObj['module_cd'] == undefined || this.joiningObj['module_cd'] == ""
      || this.joiningObj['node_cd'] == null || this.joiningObj['node_cd'] == undefined || this.joiningObj['node_cd'] == ""
    ) {
      Swal.fire("Warning", " * Fields Required.....!", 'warning');

    }
    else if (this.joiningObj['emp_phone_no'].toString().length != 10) {
      Swal.fire("Info", "...Incorrect Phone Number....!", 'info');
    }

    else {
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Add it!'
      }).then((result) => {
        if (result.value) {
          this.finalAdd()
        }
      })
    }
  }
  async finalAdd() {
    this.spinner.show();
    console.log(this.joiningObj)
    var obj: any = Object.assign({}, this.joiningObj);
    obj['b_acct_id'] = this.b_acct_id;
    obj['create_user_id'] = this.user_id;
    obj['status'] = "ACTIVE";
    obj['life_cycle_status'] = "ACTIVE";
    obj['emp_status_code'] = 'JOINING';
    obj['user_id'] = obj['le_id'];
    var today = new Date();
    var ddt = this.joiningObj['emp_dob'];
    var yr = this.underAgeValidate(today, ddt);

    var role: any = [];
    var post_data = [];
    //set node
    obj['node_cd'] = this.joiningObj['node_cd'];
    //set product
    if (this.allProduct[0]['product_cd'] != undefined) {
      obj['product'] = this.allProduct[0]['product_cd'];
    } else {
      Swal.fire("Sorry", "...Please Set A Product Before Adding any new Employee !", 'warning');
      this.spinner.hide();
      return;
    }
    //set budget
    if (this.allBudget[0]['budget_cd'] != undefined) {
      obj['budget'] = this.allBudget[0]['budget_cd'];
    } else {
      Swal.fire("Sorry", "...Please Set A Budget Before Adding any new Employee !", 'warning');
      this.spinner.hide();
      return;
    }
    var temp_module
    for (let i = 0; i < this.projecthier.length; i++) {
      if (this.planing_arrproj[1]['hierarchy_type'] == this.projecthier[i]['leaf_cd']) {
        temp_module = this.projecthier[i]['module_cd']
        post_data.push({ cost_center: this.projecthier[i]['leaf_user_cd'], module_cd: this.projecthier[i]['module_cd'], is_primary: 1 })
      }
    }

    for (let i = 0; i < this.joiningObj['module_cd'].length; i++) {
      if (temp_module != this.joiningObj['module_cd'][i]) {
        // post_data.push({ cost_center: 'NA', module_cd: this.joiningObj['module_cd'][i], is_primary: 0 })
      }
      if (role.includes(this.moduleToRole[this.joiningObj['module_cd'][i]])) {
      } else {
        role.push(this.moduleToRole[this.joiningObj['module_cd'][i]])
      }
    }

    obj['role_data'] = role;
    obj['posting_data'] = post_data;
    obj["zone"] = this.joiningObj['zone']
    console.log(obj)

    if (yr >= 18) {
      console.log(obj)
      var resp = await this.joiningservice.insertEmployeeMasterData(obj);
      console.log(resp, 'qwertyo')
      if (resp['error'] == false) {
        this.log.createLog({ ...this.logObj, activity: 'POST', message: "Employee Master Data Submitted Successfully " })
        setTimeout(async () => {
          this.joiningObj = {};
          await this.addAccountHier(resp.data, obj['emp_name'])
          // await this.getListOfAllEmployee();
          await this.dataAccessService.getCurrentDataAccess(this.b_acct_id, this.ebillUser['user_id'])
          // await this.changeEmployee();
          await this.AllEmployeeAssigedPost();
          await this.open_list();
          await this.getAllEmployees()
          this.spinner.hide();
          Swal.fire("Success", "...and Joining Completed!", 'success');
        }, 1000);
      } else {

        this.spinner.hide();
        var str = resp.data;
        if (str.includes("Duplicate")) {
          Swal.fire("Sorry", resp.data, 'warning');
        } else {
          Swal.fire("Sorry", "...There looks some error, it  will be rectify soon!", 'warning');
        }

      }
    } else {
      this.spinner.hide();

      Swal.fire("Sorry", "...You are below 18 years!", 'warning');
    }


  }
  underAgeValidate(j: any, d: any) {
    var dob = d.split('-');
    var year = parseInt(dob[0]);
    var month = parseInt(dob[1]) - 1;
    var day = parseInt(dob[2]);
    var today = new Date(j);
    var age = today.getFullYear() - year;
    if (today.getMonth() < month || (today.getMonth() == month && today.getDate() < day)) {
      age--;
    }
    return age;
  }

  async addAccountHier(final_obj: any, emp_name: any) {

    console.log(final_obj)
    console.log(emp_name)
    let level: any = 0
    let obb: any = new Object()
    obb['b_acct_id'] = this.b_acct_id

    for (let i = 0; i < this.planing_arrproj.length; i++) {
      console.log(this.planing_arrproj[i])
      //obb['lvl'+ this.planing_arrproj[i]['level']+'_user_cd'] = this.planing_arrproj[i]['level']
      if (this.planing_arrproj[i]['level'] == 1) obb['lvl' + this.planing_arrproj[i]['level'] + '_value'] = 'All Projects'

      obb['lvl' + this.planing_arrproj[i]['level'] + '_cd'] = this.planing_arrproj[i]['hierarchy_type']
      obb['lvl' + this.planing_arrproj[i]['level'] + '_value'] = this.projhierobj[this.planing_arrproj[i]['hierarchy_type']]
      obb['lvl' + this.planing_arrproj[i]['level'] + '_node_type'] = this.projhierobjtype[this.planing_arrproj[i]['hierarchy_type']]
      obb['lvl' + this.planing_arrproj[i]['level'] + '_user_cd'] = this.projhierobjtypecd[this.planing_arrproj[i]['hierarchy_type']]
      console.log(this.planing_arrproj[i]['level'], obb['lvl' + this.planing_arrproj[i]['level'] + '_user_cd'])
      level = this.planing_arrproj[i]['level']

    }

    obb['b_acct_id'] = this.ebillUser.b_acct_id;
    obb['create_user_id'] = this.ebillUser.user_id;

    obb['lvl' + (level + 1) + '_user_cd'] = 'USTPARR' + final_obj['emp_arr_id']
    obb['lvl' + (level + 1) + '_node_type'] = 'USTPEMP' //obb['node_type']
    obb['lvl' + (level + 1) + '_value'] = emp_name
    obb['lvl' + (level + 1) + '_type'] = 'text'
    obb['leaf_user_cd'] = 'USTPARR' + final_obj['emp_arr_id']
    obb['leaf_node_type'] = 'USTPEMP' //obb['node_type']
    obb['leaf_value'] = emp_name
    obb['leaf_type'] = 'text'
    obb['module_cd'] = 'USTP'
    console.log(obb);

    var resp = await this.allEmpService.createAccountproject(obb);
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'POST', message: "Account Project Hierarchy Created Successfully " })
      console.log(resp.data);
      console.log('Account Hier Project Added...')
      await this.UpdateNodeCode(resp.data, final_obj)
    } else {
      console.log('Error in Account Hier Project Added...')
      Swal.fire("Sorry", resp.data, 'warning');

    }
  }
  async UpdateNodeCode(node_cd: any, final_obj: any) {
    let proObj: any = {};
    proObj['b_acct_id'] = this.b_acct_id
    proObj['id'] = final_obj['emp_line_id'];
    proObj['node_cd'] = node_cd;
    console.log(proObj);
    var resp = await this.joiningservice.updateNodeCode(proObj);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'PUT', message: "Node Code Updated Successfully " })
      console.log('Node Code Updated....')
      await this.addDataAssnigment(node_cd, final_obj['le_id'])
    } else {
      console.log('Error in Node Code Updated....')
    }
  }
  async addDataAssnigment(node_cd: any, le_id: any) {
    let proObj1: any = {};
    proObj1['b_acct_id'] = this.b_acct_id
    proObj1['user_id'] = le_id;
    proObj1['node_cd'] = node_cd;
    proObj1['status'] = 'ACTIVE';
    proObj1['create_user_id'] = this.ebillUser.user_id;

    console.log(proObj1);
    var resp = await this.hrHierService.insertHrdataAssign(proObj1);
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'POST', message: "Data Assigned Successfully " })
      console.log("Data Assigment Done...")
      console.clear()
    } else {
      console.log("Error in Data Assigment Done...")
    }
  }
  empIdPost: any = {};
  allEmpPost: any = []
  async AllEmployeeAssigedPost() {
    console.log("All Emp Posting")
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    var resp = await this.establishmentService.getCurrentlyAssignedPost(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.log.createLog({ ...this.logObj, activity: 'GET', message: "Currently Assigned Post Received Successfully " })
      this.allEmpPost = resp.data;
      this.empIdPost = {};

      var data = resp.data;
      for (let i = 0; i < data.length; i++) {
        if ((data[i]['posting_type']) == 1) {
          this.empIdPost[data[i]['arr_id']] = data[i]['module_cd'] + "-" + data[i]['cost_center']
        }
      }
      for (let i = 0; i < data.length; i++) {
        if ((data[i]['posting_type']) != 1) {
          this.empIdPost[data[i]['arr_id']] = this.empIdPost[data[i]['arr_id']] + ",(" + data[i]['module_cd']/*  + "-" + data[i]['cost_center_desc'] */ + ")"
        }
      }
    } else {
      Swal.fire('Error', 'Some Error Occured', 'error')
    }

    console.log(this.empIdPost)
  }
}
